import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoadingOverlay from '../common/components/LoadingOverlay';
import LoadingModal from '../common/components/LoadingModal';
import FAQ from '../faq';
import OfferCard from './OfferCard';
import OfferCardLoading from './OfferCardLoading';
import AuthenticateContainer from '../app/AuthenticateContainer';

import { toggleAuthenticateModal } from '../authenticate/authenticateActions';
import { getOfferRequest, getQuotationRequest } from './offerActions';
import { getIsAnonymous, getIsAuthenticated } from '../reducers/user';

import { ping } from '../webAPI/userService';

import { Select } from '../Ui';
import Switch from '../common/components/form/Switch';
import Tooltip from '../common/components/form/Tooltip';

class OfferPage extends Component {
	constructor() {
		super();
		this.state = {
			sortValue: 'sortByPriceAsc',
			brandFilterValue: 'TOUTES LES MARQUES',
			protectedFilterValue: false,
			a2pFilterValue: false
		};
	}

	componentDidMount() {
		const { isAnonymous, isAuthenticated } = this.props;
		//const { i_am_logged_in } = this.props.params;
		//const noUser = !this.props.user;
		// if (i_am_logged_in && noUser) {
		// 	ping().then(
		// 		error => {},
		// 		result => {
		// 			this.props.pingSuccess(result);
		// 			this.props.fetchOffers();
		// 		}
		// 	);
		// 	return;
		// }
		//
		// if (noUser) {
		// 	this.props.authenticationRequired();
		// 	return;
		// }

		if (isAnonymous) {
			this.props.authenticationRequired();
			return;
		}

		if (isAuthenticated) {
			this.props.fetchOffers();
		}
	}

	render() {
		const projectId = this.props.params.projectId;

		let brands = ['TOUTES LES MARQUES'];
		this.props.offers.forEach(offer => {
			const notIn = brands.indexOf(offer.brand.name) === -1;
			if (notIn) {
				brands.push(offer.brand.name);
			}
		});

		const brandFilterOptions = brands.map(brand => {
			return { text: brand, value: brand };
		});

		const sortOptions = [
			{ text: 'Prix \u2191', value: 'sortByPriceAsc' },
			{ text: 'Prix \u2193', value: 'sortByPriceDesc' },
			{ text: 'Délai \u2191', value: 'sortByDelayAsc' },
			{ text: 'Délai \u2193', value: 'sortByDelayDesc' },
			{ text: 'Sécurité \u2191', value: 'sortBySafetyIndexAsc' },
			{ text: 'Sécurité \u2193', value: 'sortBySafetyIndexDesc' }
		];

		//this.sortByPriceAsc(this.props.offers);

		const { offers } = this.props;
		const filteredOffers = this.filter(offers);

		const sortedAndFilteredOffers = this.sortOffers(filteredOffers);

		const noOffers =
			this.props.offers.length === 0 && !this.props.isFetching;

		return (
			<div className="offer-page">
				<header className="offer-header flex">
					<div className="offer-header__container">
						<div style={{ width: '130px' }}>
							<Select
								label="trier"
								options={sortOptions}
								value={this.state.sortValue}
								onChange={value => this.setSortValue(value)}
							/>
						</div>
						<div className="flex">
							<div style={{ width: '210px' }}>
								<Select
									label="marque"
									options={brandFilterOptions}
									value={this.state.brandFilterValue}
									onChange={value =>
										this.setFilterValue(
											'brandFilterValue',
											value
										)
									}
								/>
							</div>
							<div className="offer-header__block u-flex u-flex--align-items-center">
								Clés protégées
								<Switch
									checked={this.state.protectedFilterValue}
									onChange={value =>
										this.setFilterValue(
											'protectedFilterValue',
											value.target.checked
										)
									}
								/>
							</div>
							<div className="offer-header__block u-flex u-flex--align-items-center">
								A2P
								<Tooltip className="mx-half" bottom left>
									La certification A2P (Assurance Prévention
									Protection) 1, 2 ou 3 étoiles offre des
									capacités supplémentaires de résistance aux
									tentatives d’effraction.
									<br />
									Elle est souvent préconisée dans les
									logements.
									<br />
									Un cylindre A2P doit être obligatoirement
									être associé à une serrure de même marque et
									de même niveau.
									<br />
									Cette certification émane d’une démarche
									volontaire délivrée par un organisme
									indépendant et est reconnue par les
									assureurs.
								</Tooltip>
								<Switch
									checked={this.state.a2pFilterValue}
									onChange={value =>
										this.setFilterValue(
											'a2pFilterValue',
											value.target.checked
										)
									}
								/>
							</div>
							<div className="offer-header__block u-flex u-flex--align-items-center">
								<button
									className="offer-header__btn"
									onClick={() => this.resetFilters()}
								>
									Effacer les filtres
								</button>
							</div>
						</div>
					</div>
				</header>

				{this.props.isFetching ? (
					<div className="offer-results" style={{ color: '#E2E2E2' }}>
						███████████████████
					</div>
				) : (
					<div className="offer-results">
						Nous vous proposons {sortedAndFilteredOffers.length}{' '}
						organigrammes
					</div>
				)}

				{this.props.isFetching || !this.props.isAuthenticated ? (
					<div>
						<div className="offer-wrapper">
							<OfferCardLoading />
							<OfferCardLoading />
							<OfferCardLoading />
							<OfferCardLoading />
						</div>
						<LoadingOverlay show={this.props.isFetching} />
					</div>
				) : null}

				{noOffers ? (
					<div className="offer-empty-state">
						<h1>Capitaine Clés n'a trouvé aucune offre</h1>
						<p>
							Peut-être que votre demande est trop spécifique,
							dans ce cas n'hésitez pas à demander notre aide
						</p>
					</div>
				) : sortedAndFilteredOffers.length ? (
					<div className="offer-wrapper">
						{sortedAndFilteredOffers.map(offer => {
							const productLineId =
								offer.product_line.product_line_id;
							return (
								<OfferCard
									key={productLineId}
									{...offer}
									onClick={() =>
										this.props.onOfferClick(productLineId)
									}
								/>
							);
						})}
					</div>
				) : !this.props.isFetching ? (
					<div className="offer-empty-state">
						<h1>Aucune offre ne correspond à vos filtres</h1>
						<p>
							Si vous ne trouvez pas d'offre vous satisfaisant,
							n'ésitez pas à demander notre aide
						</p>
						<button
							className="button button--primary"
							onClick={() => this.resetFilters()}
						>
							EFFACER LES FILTRES
						</button>
					</div>
				) : null}
				<div className="offer__faq">
					<FAQ />
				</div>
				{this.props.isAnonymous && <AuthenticateContainer />}
			</div>
		);
	}

	/*
		Sortby
	*/
	// sortBy(offers, sortKey, orderBy) {
	// 	if(offers[1] === undefined) return
	// 	console.log("SORTBY", offers[1]["product_line"])
	// 	// Stable sort
	// 	const offersWithPositionKey = offers.map(offer => {
	// 		offer.position = offers.indexOf(offer);
	// 		return offer;
	// 	});

	// 	return offersWithPositionKey.sort((a, b) => {
	// 		if (a[sortKey] === b[sortKey])
	// 			if(orderBy === "asc") {
	// 				return a.position - b.position;
	// 			} else {
	// 				// Desc order
	// 				return a.position + b.position;
	// 			}

	// 		if(orderBy === "asc") {
	// 			return a[sortKey] - b[sortKey];
	// 		} else {
	// 			return a[sortKey] + b[sortKey];
	// 		}
	// 	});
	// }

	sortOffers(offers) {
		const { sortValue } = this.state;
		// if(sortValue === "sortByPriceAsc") {
		// 	return this.sortBy(offers, "", "asc");
		// }
		// if(sortValue === "sortByPriceDesc") {
		// 	return this.sortBy(offers, "", "desc");
		// }
		// if(sortValue === "sortByDelayAsc") {
		// 	return this.sortBy(offers, "", "asc");
		// }
		// if(sortValue === "sortByDelayDesc") {
		// 	return this.sortBy(offers, "", "desc");
		// }
		// if(sortValue === "sortBySafetyIndexAsc") {
		// 	return this.sortBy(offers, "", "asc");
		// }
		// if(sortValue === "sortBySafetyIndexDesc") {
		// 	return this.sortBy(offers, "", "desc");
		// }
		return this[sortValue](offers);
	}

	sortByPriceAsc(offers) {
		const offersWithPositionKey = offers.map(offer => {
			offer.position = offers.indexOf(offer);
			return offer;
		});
		return offersWithPositionKey.sort((a, b) => {
			if (a.amount === b.amount) return a.position - b.position;
			return a.amount - b.amount;
		});
	}

	sortByPriceDesc(offers) {
		const offersWithPositionKey = offers.map(offer => {
			offer.position = offers.indexOf(offer);
			return offer;
		});
		return offersWithPositionKey.sort((a, b) => {
			if (a.amount === b.amount) return a.position - b.position;
			return b.amount - a.amount;
		});
	}

	sortByDelayAsc(offers) {
		const offersWithPositionKey = offers.map(offer => {
			offer.position = offers.indexOf(offer);
			return offer;
		});
		return offersWithPositionKey.sort((a, b) => {
			if (a.product_line.delay === b.product_line.delay)
				return a.position - b.position;
			return a.product_line.delay - b.product_line.delay;
		});
	}

	sortByDelayDesc(offers) {
		const offersWithPositionKey = offers.map(offer => {
			offer.position = offers.indexOf(offer);
			return offer;
		});
		return offersWithPositionKey.sort((a, b) => {
			if (a.product_line.delay === b.product_line.delay)
				return a.position - b.position;
			return b.product_line.delay - a.product_line.delay;
		});
	}

	sortBySafetyIndexAsc(offers) {
		const offersWithPositionKey = offers.map(offer => {
			offer.position = offers.indexOf(offer);
			return offer;
		});
		return offersWithPositionKey.sort((a, b) => {
			if (a.product_line.safety_index === b.product_line.safety_index)
				return a.position - b.position;
			return a.product_line.safety_index - b.product_line.safety_index;
		});
	}

	sortBySafetyIndexDesc(offers) {
		const offersWithPositionKey = offers.map(offer => {
			offer.position = offers.indexOf(offer);
			return offer;
		});
		return offersWithPositionKey.sort((a, b) => {
			if (a.product_line.safety_index === b.product_line.safety_index)
				return a.position - b.position;
			return b.product_line.safety_index - a.product_line.safety_index;
		});
	}

	setSortValue(sortValue) {
		this.setState({
			sortValue
		});
	}

	/*
		Filter
	*/
	filter(offers) {
		const {
			brandFilterValue,
			protectedFilterValue,
			a2pFilterValue
		} = this.state;
		if (brandFilterValue && brandFilterValue !== 'TOUTES LES MARQUES') {
			offers = this.filterByBrand(offers);
		}
		if (protectedFilterValue) {
			offers = this.filterByProtected(offers);
		}
		if (a2pFilterValue) {
			offers = this.filterByA2P(offers);
		}
		return offers;
	}

	filterByBrand(offers) {
		const { brandFilterValue } = this.state;
		return offers.filter(offer => offer.brand.name === brandFilterValue);
	}

	filterByA2P(offers) {
		return offers.filter(offer => offer.product_line.is_a2p);
	}

	filterByProtected(offers) {
		return offers.filter(offer => offer.product_line.is_protected);
	}

	resetFilters() {
		this.setState({
			brandFilterValue: 'TOUTES LES MARQUES',
			protectedFilterValue: false,
			a2pFilterValue: false
		});
	}

	setFilterValue(filterValueName, value) {
		this.setState({ [filterValueName]: value });
	}
}

const mapStateToProps = state => {
	return {
		isAuthenticated: getIsAuthenticated(state),
		isAnonymous: getIsAnonymous(state),
		isFetching: state.offer.isFetching,
		offers: state.offer.items
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	const { projectId } = ownProps.params;
	return {
		authenticationRequired: () => {
			dispatch(toggleAuthenticateModal());
		},
		fetchOffers: () => {
			dispatch(getOfferRequest(projectId));
		},
		onOfferClick: productLineId => {
			dispatch(getQuotationRequest(projectId, productLineId));
		},
		pingSuccess(result) {
			dispatch({
				type: 'PING_SUCCESS',
				result
			});
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferPage);



// WEBPACK FOOTER //
// ./src/js/offer/index.js